import React from 'react'
import DateInputCustom from './DateInputCustom'

export default function DateRangeInputCustom(props) {
  return (
    <React.Fragment>
      <DateInputCustom
        label={props.fromLabel}
        placeholder={props.fromPlaceholder}
        disabled={props.disabled}
        loading={props.loading}
        transparent={props.transparent}
        error={props.error}
        value={props.from}
        onChange={props.onFromChange}
      />

      <DateInputCustom
        label={props.toLabel}
        placeholder={props.toPlaceholder}
        disabled={props.disabled}
        loading={props.loading}
        transparent={props.transparent}
        error={props.error}
        value={props.to}
        onChange={props.onToChange}
      />
    </React.Fragment>
  )
}

DateRangeInputCustom.defaultProps = {
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  fromLabel: 'Fecha Inicio',
  fromPlaceholder: 'Fecha Inicio',
  from: null,
  onFromChange: () => { },
  toLabel: 'Fecha Fin',
  toPlaceholder: 'Fecha Fin',
  to: null,
  onToChange: () => { },
}
